const fromdataedit = [
	{
	  inputdata: '借口管理',
	  title: '父级菜单',
	  fontSize: '14px',
	  color: '#333333',
	  placeholder: '请选择',
	  types: '',
	  inputtype: 'select',
	  width: '490px'
	},
	{
		inputdata: 'API02',
		title: '菜单编码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	},
	{
		inputdata: '发票二次校验',
		title: '菜单名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	},
	{
		inputdata: '/Helper/Check2invvoice',
		title: '菜单链接',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	},
	{
		inputdata: "1000",
		title: "优先级",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "number",
		width: "490px",
		min: '1',
		max: '1000',
	},
]
export default fromdataedit;
